import { useSessionMessageApi } from '../../../../utils/actionableNotifications';
import React, { useState } from "react";
import { Button, Tooltip } from 'antd';
import { UserOutlined } from "@ant-design/icons";
import { useCustomerProfile } from "../../viewmodels/shared/useCustomerProfile";
import { useCustomerProfileLauncher } from "./CustomerProfileLauncherContext";

export function CustomerProfileButton({ phone, size = "small", onBeforeOpen }) {
  const message = useSessionMessageApi();
  const { loadByPhone, create } = useCustomerProfile();
  const launcher = useCustomerProfileLauncher();
  const [loading, setLoading] = useState(false);
  const openProfile = (customer) => {
    if (!launcher) return;
    onBeforeOpen?.();
    launcher.openCustomerProfile(customer);
  };

  const fetchAndOpen = async () => {
    if (!phone) return;
    setLoading(true);
    try {
      let found = await loadByPhone(phone);
      if (found) {
        openProfile(found);
        return;
      }
      await create({ name: phone, number: phone });
      message.success("Saved the customer automatically");
      found = await loadByPhone(phone);
      if (found) {
        openProfile(found);
      } else {
        message.error("Could not load customer profile");
      }
    } catch (e) {
      message.error(e.message || "Failed to load customer profile");
    } finally {
      setLoading(false);
    }
  };

  // A single wrapping element (not a Fragment) so this component is always
  // exactly one flex item wherever it's embedded — a Fragment here would
  // flatten the Drawer's stopPropagation div in as a second, invisible flex
  // sibling next to the button, throwing off flex layouts like
  // justifyContent: space-between in the host row.
  return (
    <span onClick={e => e.stopPropagation()} style={{ display: "inline-flex" }}>
      <Tooltip title="Open customer profile">
        <Button
          type="text"
          size={size}
          loading={loading}
          icon={<UserOutlined />}
          onClick={fetchAndOpen}
          style={{ padding: "0 4px" }}
        />
      </Tooltip>
    </span>
  );
}
